import {
  AfterViewInit,
  Component,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import PolarInterface from './PolarInterface'; // Make sure the path is correct

@Component({
  selector: 'app-polar-interface',
  template: `<div [id]="rootId" style="transition: 0.6s"></div>`,
  encapsulation: ViewEncapsulation.None
})
export class ReactWrapperComponent implements OnChanges, OnDestroy, AfterViewInit {
  public rootId = 'polar-interface-root';

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngAfterViewInit(): void {
    this.render();
  }

  ngOnDestroy(): void {
    ReactDOM.unmountComponentAtNode(document.getElementById(this.rootId) as Element);
  }

  private render(): void {
    ReactDOM.render(
      React.createElement(PolarInterface),
      document.getElementById(this.rootId)
    );
  }
}

export default ReactWrapperComponent